import { render, staticRenderFns } from "./ElementsMedia.vue?vue&type=template&id=2010fb52"
import script from "./ElementsMedia.vue?vue&type=script&lang=js"
export * from "./ElementsMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports